import React, { useState } from 'react'
import { Header } from 'components/Header'
import { Button, Flex, Message } from '@workwhile/ui'
import { QueryStatus } from 'components/QueryStatus'
import { useCompumaticClockPunchesContextValue } from '../context/CompumaticClockPunchesProvider'
import { ReprocessConfirmModal } from './ReprocessConfirmModal'
import { IgnoreConfirmModal } from './IgnoreConfirmModal'

export const CompumaticClockPunchesHeader = () => {
  const { state, actions } = useCompumaticClockPunchesContextValue()
  const [isReprocessConfirmOpen, setIsReprocessConfirmOpen] = useState(false)
  const selectedCount = state.selectedPunchIds.length
  const ignoreConfirmCount = state.ignore.confirmPunchIds?.length ?? 0
  const isBulkActionPending =
    state.reprocess.isPending || state.ignore.isPending

  const handleConfirmReprocess = () => {
    actions.reprocessSelectedPunchIds(() => setIsReprocessConfirmOpen(false))
  }

  const handleConfirmIgnore = () => {
    actions.confirmIgnorePunchIds()
  }

  return (
    <>
      <Header
        title="Compumatic Clock Punches"
        rightContent={
          <Flex alignItems="center" gap={2}>
            {state.reprocess.isError && state.reprocess.errorMessage ? (
              <Message variant="error" m={0}>
                {state.reprocess.errorMessage}
              </Message>
            ) : null}
            {state.ignore.isError && state.ignore.errorMessage ? (
              <Message variant="error" m={0}>
                {state.ignore.errorMessage}
              </Message>
            ) : null}
            <QueryStatus
              dataUpdatedAt={state.dataUpdatedAt}
              isFetching={state.isFetching}
              refetch={actions.refetch}
              isError={state.isError}
              error={state.error}
            />
            <Button
              variant="secondary"
              kind="medium"
              disabled={
                selectedCount === 0 ||
                isBulkActionPending ||
                state.ignore.confirmPunchIds !== null
              }
              onClick={() => actions.openIgnoreConfirm(state.selectedPunchIds)}
            >
              Ignore
              {selectedCount > 0 ? ` (${selectedCount})` : ''}
            </Button>
            <Button
              variant="primary"
              kind="medium"
              disabled={selectedCount === 0 || isBulkActionPending}
              onClick={() => setIsReprocessConfirmOpen(true)}
            >
              Reprocess
              {selectedCount > 0 ? ` (${selectedCount})` : ''}
            </Button>
          </Flex>
        }
      />
      <ReprocessConfirmModal
        open={isReprocessConfirmOpen}
        selectedCount={selectedCount}
        isPending={state.reprocess.isPending}
        onClose={() => setIsReprocessConfirmOpen(false)}
        onConfirm={handleConfirmReprocess}
      />
      <IgnoreConfirmModal
        open={state.ignore.confirmPunchIds !== null}
        selectedCount={ignoreConfirmCount}
        isPending={state.ignore.isPending}
        onClose={actions.closeIgnoreConfirm}
        onConfirm={handleConfirmIgnore}
      />
    </>
  )
}
